import React from 'react';
import { connect } from 'react-redux';
import Button from 'src/ui/library/Button';
import adobeLaunch from 'src/helpers/adobeLaunch';
import intl from 'react-intl-universal';
import { fetchServiceInitiations, fetchServiceInitiationFilters } from 'src/services/serviceinit.service.js';
import { SERVICEINIT_DETAILS_URL, SERVICEINIT_URL_BATCHSI, LAUNCH_ADOBE } from 'src/constants/constants';
import { createRowMap, createTableColumns, urlParamsMapper } from 'src/helpers';
import { isCorpClientSelector, isApplicantSelector } from 'src/ui/features/Login/state/loginReselect';
import { addToHistory } from 'src/utils/utilsActions';
import { StorageService } from 'src/helpers/localStorageService';
import { fireViewStartCustomEvent } from 'src/helpers/adobeCustomEvents';
//import { trackClickAnalytics /*trackSearchAnalytics*/ } from 'src/helpers/adobeUtils';
import { TableLanding } from 'src/ui/library/Table/extensions';
import { PageTitle } from 'src/ui/library/PageTitle';
import { formatDate } from 'src/helpers/date';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import { fnShowNewDashboard, fnGetIsAllDataFlag } from 'src/helpers/commonFunctions';

const useStyles = color => ({
  switch: {
    '& .Mui-checked': {
      color: 'green',
    },
    '& .MuiSwitch-track': {
      backgroundColor: 'green !important',
    },
  },
  formControlLabel: {
    color: 'green',
  },
});
class ServiceInitLandingContainer extends React.Component {
  isOnLoad = true;
  constructor(props) {
    super(props);
    this.tableLandingRef = React.createRef();
    this.cancelTokenFn = null;
    if (LAUNCH_ADOBE) {
      let launch = new adobeLaunch();
      launch._load().then(() => {
        let storageService = new StorageService();
        storageService.setItem('pageName', 'service initiation');
        window.digitaldata.page.pageName = storageService.getItem('pageName');
        window.digitaldata.user.userId = storageService.getItem('userId');
      });

      fireViewStartCustomEvent({ detail: { mbox: 'target-global-mbox' } });
    }
  }

  defaultToggleValue = () => (!this.props.isApplicant && fnShowNewDashboard() ? fnGetIsAllDataFlag() : null);
  componentDidMount() {
    this.props.addToHistory(window.location.pathname);
  }

  getTableColumns = () => {
    const corpColumns = ['employeeApplicantName', 'statusname', 'initiationId', 'initiationType', 'dateCreated', 'draftDate', 'services'];
    const allColumns = ['engagement', 'employeeApplicantName', 'statusname', 'initiationId', 'initiationType', 'dateCreated', 'draftDate'];

    const columnsName = [
      'engagement',
      'employeeApplicantName',
      'statusname',
      'initiationId',
      'initiationType',
      'dateCreated',
      'draftDate',
      'assigneeServicePlanGlobalId',
      'organizerTypeId',
      'yearTypeId',
      'si_Id',
      'services',
    ];

    /* Create columns config object used in <Table /> */
    const columns = createTableColumns('serviceInit.landing', {
      columns: columnsName,
      visible: this.props.isCorpClient ? corpColumns : allColumns,
      options: {
        employeeApplicantName: {
          sortable: false,
        },
        employeeCode: {
          sortable: false,
        },
        engagement: {
          sortable: false,
        },
        dateCreated: {
          renderComponent: value => {
            return value;
          },
        },
        draftDate: {
          renderComponent: value => {
            return formatDate(value);
          },
        },
        services: {
          sortable: false,
        },
      },
    });

    return columns;
  };

  getFastFilters = response => {
    return [
      { id: 'all', label: 'All', value: response.allCount, defaultSelected: true },
      { id: 'isVip', label: 'VIP', value: response.vipCount },
      // { id: 'allData', label: 'All Data', value: response.allCount },
    ];
  };

  toggleOptions = (filterId, response) => {
    let options = [
      { id: 'isAllData', label: intl.get('serviceInit.landing.myData'), value: response ? response.allCount : '' },
      { id: 'allData', label: intl.get('serviceInit.landing.allData'), value: response ? response.allCount : '' },
    ];
    if (filterId) {
      return options[filterId === 'isAllData' ? 0 : 1].label;
    }
    return options;
  };
  getToggleFilters = response => this.toggleOptions(null, response);

  getGridFilters = response => {
    const { employeeList, policyList, countryList } = response;

    /* Build Dropdown options */
    const employeeOpts = employeeList ? employeeList.map((item, index) => ({ value: item.employeeId, label: item.employeeName })) : [];
    const policyOpts = policyList ? policyList.map((item, index) => ({ value: item.policyId, label: item.policyName })) : [];
    const countryOpts = countryList ? countryList.map((item, index) => ({ value: item.countryId, label: item.countryName })) : [];

    /* Create config used for <TableFilter /> */
    const config = [
      {
        id: 'employeeId',
        controlType: 'Dropdown',
        label: intl.get('serviceInit.landing.filters.employeeApplicant'),
        options: employeeOpts,
      },
      {
        id: 'policyId',
        controlType: 'Dropdown',
        label: intl.get('serviceInit.landing.filters.policy'),
        options: policyOpts,
      },
      { id: 'dateCreatedFrom', controlType: 'Date', label: intl.get('serviceInit.landing.filters.dateCreatedFrom') },
      { id: 'dateCreatedTo', controlType: 'Date', label: intl.get('serviceInit.landing.filters.dateCreatedTo') },
      { id: 'dateStartedFrom', controlType: 'Date', label: intl.get('serviceInit.landing.filters.dateStartedFrom') },
      { id: 'dateStartedTo', controlType: 'Date', label: intl.get('serviceInit.landing.filters.dateStartedTo') },
      {
        id: 'homeCountryId',
        controlType: 'Dropdown',
        label: intl.get('serviceInit.landing.filters.homeCountry'),
        options: countryOpts,
      },
      {
        id: 'hostCountryId',
        controlType: 'Dropdown',
        label: intl.get('serviceInit.landing.filters.hostCountry'),
        options: countryOpts,
      },
    ];

    return config;
  };

  onTableChange = (actionType, data, { setTableState, fetchData }) => {
    switch (actionType) {
      case 'viewDetail':
      case 'rowClick':
        const {
          model: { columns, rows },
          rowClicked: { origRowIndex },
        } = data;

        const rowData = createRowMap(columns, rows[origRowIndex]);

        const ssiDetailUrl = urlParamsMapper(SERVICEINIT_DETAILS_URL, {
          serviceInitiationId: rowData.si_Id,
        });

        this.props.history.push({
          pathname: ssiDetailUrl,
          state: {
            isEmployeeSelected: rowData.employeeCode != null && rowData.employeeCode !== '',
            isDraft: rowData.statusname && rowData.statusname === 'Draft',
          },
        });

        break;

      case 'fastFilter':
        const { all, isAllData, allData, ...otherFilters } = data;
        let newFilters = {};

        if (all) {
          Object.entries(otherFilters).forEach(([filter, val]) => {
            newFilters[filter] = undefined;
          });
          newFilters.isVip = undefined;
        } else if (isAllData) {
          newFilters.isAllData = false;
        } else if (allData) {
          newFilters.isAllData = true;
        } else {
          Object.entries(otherFilters).forEach(([filter, val]) => {
            newFilters[filter] = val || undefined;
          });
        }
        setTableState({ filters: newFilters }, () => fetchData());
        if (this.tableLandingRef && this.tableLandingRef.current) this.tableLandingRef.current.resetPage();
        break;

      default:
        return undefined;
    }
  };
  getPayloadModel = (payload, stateObj) => {
    if (this.isOnLoad) {
      payload.isAllData = this.defaultToggleValue();
      this.isOnLoad = false;
    }
    return payload;
  };

  render() {
    const { classes } = this.props;
    let isDefaultOldView = !fnShowNewDashboard();
    return (
      <React.Fragment>
        <PageTitle title={intl.get('serviceInit.landing.pageTitle')} />
        <div className={isDefaultOldView ? '' : 'svc-landing-cnt'}>
          <Grid container className="serviceInitHeader" spacing={2} direction="row">
            <Grid item md={12}>
              <div className="serviceInitHeaderNew">
                <div className="font-18 font-bold mb-10">{intl.get('serviceInit.landing.title')}</div>
              </div>
            </Grid>
            <TableLanding
              ref={this.tableLandingRef}
              history={this.props.history}
              columns={this.getTableColumns()}
              sortDirection={'desc'}
              sortColumn={'initiationId'}
              actionable={true}
              fastFilter={{
                filters: response => this.getFastFilters(response),
              }}
              toggleFilter={{
                filters: response => this.getToggleFilters(response),
              }}
              onModifyRequest={(payload, stateObj) => this.getPayloadModel(payload, stateObj)}
              isFromDocuments={isDefaultOldView ? false : true}
              LToggle={intl.get('serviceInit.landing.myData')}
              RToggle={intl.get('serviceInit.landing.allData')}
              switchStyles={classes}
              gridFilter={{
                filters: response => this.getGridFilters(response),
                render: TableFilter => (
                  <div className="landing-gridfilter-container">
                    {TableFilter}
                    <Button
                      className="add-initiation-btn-ssi"
                      styleType="primary"
                      onClick={() => this.props.history.push(SERVICEINIT_URL_BATCHSI)}>
                      <span>{intl.get('serviceInit.landing.topBar.addInitiation')}</span>
                    </Button>
                  </div>
                ),
              }}
              onRequestData={fetchServiceInitiations}
              onRequestFilters={fetchServiceInitiationFilters}
              onTableChange={this.onTableChange}
              onLoadToggleSelectedValue={
                this.defaultToggleValue() !== null ? this.toggleOptions(fnGetIsAllDataFlag() ? 'allData' : 'isAllData') : null
              }
            />
          </Grid>
        </div>
      </React.Fragment>
    );
  }
}

const mapDispatchToProps = {
  addToHistory,
};

const mapStateToProps = state => ({
  isApplicant: isApplicantSelector(state),
  isCorpClient: isCorpClientSelector(state),
});

const dash = connect(mapStateToProps, mapDispatchToProps)(ServiceInitLandingContainer);
export default withStyles(useStyles)(dash);
